import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventProfile extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventProfile';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            name: false,
            ev_lastname:false,
            ev_empolyeeid:false,
            ev_agencyid:false,
            ev_title:false,
            ev_email:false,
            ev_company:false,
            ev_department:false,
            ev_job_title:false,
            ev_office_phone:false,
            ev_country_code:false,
            ev_mobile:false,
            ev_token:false,
            ev_remarks:false,
            ev_sms:false,
            ev_vip_flag:false,
            ev_exclude_email_reminder:false,
        }
    }

    // static setupInstance(data, { models }) {
    //     console.log("Setup Instance in EventsProfile:",data);
    //     if (data) {
    //         const tempdata= new models.api.EventProfile(data.EventLayout)
    //         console.log(tempdata)
    //     }
    //     return data
    // }
}

const servicePath = 'events-profile';
const servicePlugin = makeServicePlugin({
    Model: EventProfile,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin